import { Navigate, useParams } from "react-router";

import { CoInvestmentFullPaths, CommonPaths } from "@vega-modules/paths";

export const CoInvestmentDetailsPage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate replace to={CommonPaths.NotFound} />;
  }

  return (
    <Navigate
      replace
      to={CoInvestmentFullPaths.CoInvestmentLpOverview.replace(":id", id)}
    />
  );
};
